import PaginationBlock from './pagination-block';

export default PaginationBlock;
